import {
  GET_PRODUCT_TUTOR,
  FETCH_START,
  FETCH_SUCCESS,
  FETCH_ERROR,
  SET_PAGE,
  SET_SEARCH,
  SET_PRODUCT_ID,
  SET_ORDER_BY,
  SET_SORT_BY,
  SHOW_MESSAGE,
} from "../../shared/constants/ActionTypes";

import jwtAxios from "@crema/services/auth/jwt-auth/jwt-api";

export const getProductTutor = (limit = 10) => {
  return (dispatch, getState) => {
    const state = getState().eh_productTutor;
    dispatch({ type: FETCH_START });
    jwtAxios
      .post("/product/get-tutors", {
        page: state.page,
        id: state.courseId,
        limit,
      })
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: GET_PRODUCT_TUTOR,
            payload: data.data.data,
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const addProductTutor = (payload) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .post("/product/update-tutor", payload)
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: SHOW_MESSAGE,
            payload: "Product tutor added successfully",
          });
          dispatch(getProductTutor());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const deleteProductTutor = (payload) => {
  return (dispatch) => {
    dispatch({ type: FETCH_START });
    jwtAxios
      .post("/product/delete-tutor", payload)
      .then((data) => {
        if (data.status === 200) {
          dispatch({ type: FETCH_SUCCESS });
          dispatch({
            type: SHOW_MESSAGE,
            payload: "Product tutor deleted successfully",
          });
          dispatch(getProductTutor());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: "Something went wrong, Please try again!",
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: error.response?.data?.msg
            ? error.response?.data?.msg
            : error.message,
        });
      });
  };
};

export const setPage = (page) => {
  return (dispatch) => {
    dispatch({ type: SET_PAGE, payload: page });
  };
};

export const setSearch = (search) => {
  return (dispatch) => {
    dispatch({ type: SET_SEARCH, payload: search });
  };
};

export const setCourseId = (courseId) => {
  return (dispatch) => {
    dispatch({ type: SET_PRODUCT_ID, payload: courseId });
  };
};
export const setOrderBy = (orderby) => {
  return (dispatch) => {
    dispatch({ type: SET_ORDER_BY, payload: orderby });
  };
};
export const setSortBy = (sortby) => {
  return (dispatch) => {
    dispatch({ type: SET_SORT_BY, payload: sortby });
  };
};
